<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-light
                  text-primary
                  border-primary
                  font-size-22
                "
              >
                <i class="bx bx-world bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("website.website-cms-checker") }}</h5>
            </div>
          </div>
          <div class="row mt-5 mb-3">
            <div class="col-sm-12 text-right">
              <div class="input-group">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="searchKey"
                  v-on:input="removeHttp(searchKey)"
                  placeholder="domainname.com"
                  aria-describedby="search"
                  @keyup.enter="searchWebsite"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="searchWebsite"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loading" class="row mt-5 mb-5 pb-4 mx-auto">
            <div class="text-center">
              <div
                class="spinner-border text-secondary"
                role="status"
                v-if="loading"
              >
                <span class="sr-only"
                  ><p>{{ $t("website.website-location") }}</p></span
                >
              </div>
            </div>
          </div>
          <div
            v-if="error !== '' && !loading"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-danger">{{ error }}</span>
            </div>
          </div>
          <div
            v-if="!cms[0] && sm == '' && !loading && search"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center text-secondary">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div>
            <div class="row mt-4" v-if="SearchResult">
              <div class="col-sm-12">
                <label v-if="cms[0]"><b>CMS :</b></label>
                <p v-for="(data, index) in cms" :key="index">
                  <span>
                    {{ data.name }}:
                    <span class="text-success">{{
                      data.categories
                    }}</span></span
                  >
                </p>

                <label v-if="sm" class="mt-3"
                  ><b>{{ $t("website.social_media") }}:</b></label
                >
                <p v-for="(data, index) in sm" :key="index">
                  <span>
                    {{ data.network }}:
                    <a
                      :href="data.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="text-success"
                    >
                      [ {{ data.profile }} ]</a
                    ></span
                  >
                </p>
              </div>
              <div class="col-sm-12 text-right" v-if="cms[0] || sm">
                <b-button
                  class="btn"
                  variant="secondary"
                  size="sm"
                  @click="clearData"
                  ><i class="fa fa-times"></i>
                  {{ $t("website.clear") }}</b-button
                >
                <b-button
                  class="btn"
                  variant="success"
                  size="sm"
                  @click="saveCMS"
                  ><i class="fa fa-check"></i>
                  {{ $t("website.save") }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-sm-6">
        <h5>{{ $t("website.list_web_cms") }}</h5>
      </div>
      <div class="col-sm-6 text-right"></div>
    </div>

    <div class="row mt-2 mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-0"
                    ></b-form-select
                    >&nbsp;&nbsp;
                  </label>
                  {{ $t("all.entries") }}
                  <b-button
                    class="btn btn-sm ml-3"
                    variant="danger"
                    @click="bulkAction()"
                    v-if="selected[0]"
                    >{{ $t("button.bulk") }} {{ selected.length }}
                    {{ $t("button.row-data") }}
                  </b-button>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #head(bulk) width="4%">
                  <b-form-checkbox
                    v-model="selectAll"
                    @change="select"
                    class="text-center mt-0"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(bulk)="row" width="4%">
                  <b-form-checkbox
                    class="text-center mt-0"
                    v-model="selected"
                    :value="row.item.id_cms"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(result)="row">
                  <div>
                    <span
                      v-for="(data, index) in JSON.parse(row.item.result)"
                      :key="index"
                    >
                      {{ data.name }},
                    </span>
                  </div>
                </template>
                <template #cell(social_media)="row">
                  <div>
                    <b>{{ row.item.social_media }}</b>
                    {{ $t("website.social_media") }}
                  </div>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      name: 'cms-checker-detail',
                      params: { id: row.item.id_cms },
                    }"
                    ><b-button class="mr-1 btn-sm mb-1" variant="secondary">
                      <i class="bx bx-show-alt"></i> </b-button
                  ></router-link>
                  <b-button
                    class="mr-0 btn-sm mb-1"
                    variant="danger"
                    @click="deleteWebCMS(row.item.id_cms)"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                </template>
              </b-table>
              <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                    v-if="loadingInfo"
                  >
                    <span class="sr-only"
                      ><p>{{ $t("website.website-info") }}</p></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="!loadingInfo && rows > 10">
                <div class="col-2 col-xl-1">
                    <!-- <div v-if="selected[0]">
                    <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                    </div> -->
                    <label class="d-inline-flex align-items-center">
                    Page
                    <b-form-input
                        v-model="currentPage"
                        placeholder="Page"
                        class="form-control w-10 form-control ml-2"
                    ></b-form-input>
                    </label>
                </div>
                <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Tools Website",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      urlimage: "http://localhost:8001/api/target/image-project?name=",
      loading: false,
      loadingInfo: false,
      search: false,
      searchKey: "",
      SearchResult: "",
      cms: "",
      sm: "",
      total_results: "",
      tableData: [],
      selected: [],
      selectAll: false,
      error: "",
      is_spam: "",
      title: this.$t("website.website-cms-checker"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("website.website-cms-checker"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "no",  class: 'text-center', thStyle: { width: "2%" }, label:'No'},
        { key: "bulk", thStyle: { width: "2%" }, label: "#" },
        { key: "id_cms", thClass: "d-none", tdClass: "d-none" },
        {
          key: "domain_name",
          thStyle: { width: "25%" },
          label: this.$t("website.domain_name"),
          sortable: true,
        },
        { key: "result", thStyle: { width: "35%" }, label: "CMS" },
        {
          key: "social_media",
          label: this.$t("website.social_media"),
          sortable: true,
        },
        {
          key: "actions",
          class: "text-center",
          thStyle: { width: "15%" },
          label: this.$t("website.actions"),
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.tableData) {
          this.selected.push(this.tableData[i].id_cms);
        }
      }
    },

    searchWebsite() {
      this.error = "";
      (this.loading = true), (this.search = true);
      this.SearchResult = "";
      const data = {
        website: this.searchKey,
      };
      WebsiteService.searchWebCms(data)
        .then((response) => {
          this.SearchResult = response.data.output;
          this.cms = response.data.output.result;
          this.sm = response.data.output.social_media;
          this.search = true;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          if (err.response.status == 500) {
            this.error = this.$t("all.error-500");
          } else if (err.response.status == 404) {
            this.error = this.$t("all.error-404");
          }
        });
    },
    saveCMS() {
      this.loadingsave = true;
      var data = {
        domain_name: this.searchKey,
        result: JSON.stringify(this.SearchResult.result),
        social_media: JSON.stringify(this.SearchResult.social_media),
      };

      WebsiteService.createWebCmsChecker(data)
        .then((response) => {
          this.searchKey = "";
          this.loading = false;
          this.cms = "";
          this.sm = "";
          this.SearchResult = "";
          Swal.fire(response.data.message, "", "success");
          this.getWebsiteCMSUpdate();
          this.search = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.search = false;
        });
    },
    getWebsiteCMS() {
      this.loadingInfo = true;
      WebsiteService.getWebCmsChecker()
        .then((response) => {
          this.tableData = [];
          response.data.data.forEach((val, index) => {
            const data = {
              no: index+1,
              domain_name: val.domain_name,
              id_cms: val.id_cms,
              result: val.result,
              social_media: JSON.parse(val.social_media).length,
            };
            this.tableData.push(data);
          });
          this.total_results = response.data.data.length;
          this.loadingInfo = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingInfo = false;
        });
    },

    getWebsiteCMSUpdate() {
      WebsiteService.getWebCmsChecker()
        .then((response) => {
          this.tableData = [];
          response.data.data.forEach((val, index) => {
            const data = {
              no: index+1,
              domain_name: val.domain_name,
              id_cms: val.id_cms,
              result: val.result,
              social_media: JSON.parse(val.social_media).length,
            };
            this.tableData.push(data);
          });
          this.total_results = response.data.data.length;
          this.loadingInfo = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingInfo = false;
        });
    },
    deleteWebCMS(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          WebsiteService.deleteWebCmsChecker(id)
            .then((response) => {
              this.getWebsiteCMS();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    bulkAction() {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = this.selected;
          WebsiteService.websiteBulkWebCms(data)
            .then((response) => {
              this.selected = [];
              this.getWebsiteCMS();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: this.$t("alert.alert-delete-web"),
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    clearData() {
      this.SearchResult = "";
      this.searchKey = "";
    },

    formatDate(value) {
      return moment(value).format("dddd, YYYY-MM-DD hh:mm");
    },
    removeHttp(url) {
      let x = url
        .replace(/(^\w+:|^)\/\//, "")
        .replace("/", "")
        .replace("www.", "");
      return (this.searchKey = x);
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getWebsiteCMS();
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>